// extracted by mini-css-extract-plugin
export var body = "k_B";
export var layout = "k_Q";
export var menu = "k_R";